import type { JSX, ReactNode } from 'react';

import { Box, Typography } from '@mui/material';


interface UploadDialogData {
  title: ReactNode;
  subtitle: ReactNode;
  body: ReactNode;
}

interface UploadDialogProps {
  dialog: UploadDialogData;
}

const UploadDialog = ({
  dialog
}: UploadDialogProps): JSX.Element => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start'
    }}
  >
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
      }}
    >
      <Typography
        sx={{
          textAlign: 'left',
          font: 'var(--sprout-font-h2)',
          color: 'var(--sprout-text-primary)',
          fontSize: {
            xs: '28px !important',
            sm: '32px !important'
          },
          lineHeight: {
            xs: '36px !important',
            sm: '42px !important'
          },
          mb: 'var(--corner-radius-lg)'
        }}
      >
        {dialog.title}
      </Typography>

      <Typography
        component="h4"
        sx={{
          font: 'var(--sprout-font-body1) !important',
          color: 'var(--sprout-text-primary)',
          textAlign: 'left',
          mb: 'var(--corner-radius-lg)'
        }}
      >
        {dialog.subtitle}
      </Typography>
    </Box>

    <Box sx={{ textAlign: 'left', width: '100%' }}>
      {dialog.body}
    </Box>
  </Box>
);

export default UploadDialog;